var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var stdin_exports = {};
__export(stdin_exports, {
  default: () => mergeArray
});
module.exports = __toCommonJS(stdin_exports);
function mergeArray(arr1, arr2, key, upsert) {
  const idIndexMap = {};
  const ans = [];
  const finalUpsert = upsert || ((_, n) => n);
  const procArray = (arr) => {
    arr.forEach((nit) => {
      if (!nit)
        return;
      const iKey = nit[key];
      if (!iKey)
        return;
      const index = idIndexMap[iKey];
      if (typeof index !== "number") {
        ans.push(nit);
        idIndexMap[iKey] = ans.length - 1;
      } else {
        ans[index] = finalUpsert(ans[index], nit);
      }
    });
  };
  if (arr1)
    procArray(arr1);
  if (arr2)
    procArray(arr2);
  return ans;
}
